import React from 'react';
import { Card, Col, Row, Form, Table } from 'react-bootstrap';
import { FaTrash } from 'react-icons/fa'; // Importa o ícone de lixeira

const UnitsForm = ({ permissions, unit, selectedUnits, setSelectedUnits, openModalExcluir }) => {

    const handleCheckboxChange = (event) => {
        if (event.target.checked) {
            setSelectedUnits((prevSelected) => [...prevSelected, unit._id]);
        } else {
            setSelectedUnits((prevSelected) => prevSelected.filter(id => id !== unit._id));
        }
    };

    return (
        <Card className='mb-2 mt-2 p-2 box-sh'>
            <Row>
                <Col md={10}>
                    <h5>{unit.name || "--"}</h5>
                    <h6>{unit.cnpj || "--"}</h6>
                </Col>
                <Col md={2} className='text-center mt-3'>
                    <Form.Check type="checkbox">
                        <Form.Check.Input
                            type="checkbox"
                            onChange={handleCheckboxChange}
                            checked={selectedUnits?.includes(unit._id)}
                            disabled={!permissions?.write}
                            isValid
                        />
                    </Form.Check>
                </Col>
            </Row>

            <Table style={{ fontSize: "0.8rem" }} striped bordered hover responsive size='sm'>
                <thead>
                    <tr className="table-secondary text-center">
                        <th>Configuração</th>
                        <th>Máximo</th>
                        <th>Mínimo</th>
                        <th>Notificação</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Umidade</td>
                        <td className='text-center'>{unit?.configs?.maxHumidity || "--"}</td>
                        <td className='text-center'>{unit?.configs?.minHumidity || "--"}</td>
                        <td className='text-center'>{unit?.notification?.changeHumidity ? "Ativo" : "Inativo"}</td>
                    </tr>
                    <tr>
                        <td>Temperatura</td>
                        <td className='text-center'>{unit?.configs?.maxTemperature || "--"}</td>
                        <td className='text-center'>{unit?.configs?.minTemperature || "--"}</td>
                        <td className='text-center'>{unit?.notification?.changeTemperature ? "Ativo" : "Inativo"}</td>
                    </tr>
                    <tr>
                        <td>Densidade</td>
                        <td className='text-center'>{unit?.configs?.maxDensity || "--"}</td>
                        <td className='text-center'>{unit?.configs?.minDensity || "--"}</td>
                        <td className='text-center'>{unit?.notification?.changeDensity ? "Ativo" : "Inativo"}</td>
                    </tr>
                    <tr>
                        <td>PH</td>
                        <td className='text-center'>{unit?.configs?.maxPH || "--"}</td>
                        <td className='text-center'>{unit?.configs?.minPH || "--"}</td>
                        <td className='text-center'>{unit?.notification?.changePH ? "Ativo" : "Inativo"}</td>
                    </tr>
                </tbody>

                <thead>
                    <tr className="table-secondary text-center">
                        <th colSpan={4}>E-mails de Notificação</th>
                    </tr>
                </thead>
                <tbody>
                    {unit?.notification?.notifyTo?.length ? (
                        unit.notification.notifyTo.map((email, index) => (
                            <tr key={index}>
                                <td colSpan={3}>{email}</td>
                                <td className="text-center">
                                    <FaTrash
                                        style={{ color: 'grey', cursor: 'pointer' }}
                                        onClick={() => permissions.write && openModalExcluir(unit._id, email)} // Função para exclusão
                                        title="Excluir e-mail"
                                    />
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td className="text-center" colSpan={4}>Nenhum E-mail Cadastrado!</td>
                        </tr>
                    )}
                </tbody>
            </Table>
        </Card>
    );
};

export default UnitsForm;